import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import breakPoints from 'helpers/Styles';
import Image from 'next/image';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ImageGalleryMobile = ({
  imagesGallery,
  showModal,
  handleModalOpen,
  handleImageIndex,
  productTitle,
}) => {
  
  return (
    <>
      <div className="product_image_container">
        <Carousel
          showStatus={false}
          showThumbs={false}
          showArrows={false}
          swipeable={true}
          emulateTouch={true}
          useKeyboardArrows
          infiniteLoop
          autoPlay
          interval={5000}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            const indicatorStyle = {
              width: '28px',
              height: isSelected ? '4px' : '2px',
              backgroundColor: isSelected ? '#cbcbcb' : '#626262',
              display: 'inline-block',
              marginLeft: '4px',
              cursor: 'pointer',
            };
  
            return (
              <span
                style={indicatorStyle}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                aria-label={`${label} ${index + 1}`}
              />
            );
          }}
        >
          {imagesGallery.map((item, id) => {
            return (
              <div className="image_tab" key={id}>
                <div className="product_image">
                  <Image
                    draggable={false}
                    src={item.node.originalSrc}
                    alt={
                      item?.node?.altText !== null
                        ? item.node.altText
                        : productTitle
                    }
                    width={350}
                    height={350}
                  />
                </div>
  
                {/* <div className="image_zoom_in">
                  <Image draggable={false} 
                    src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-magnifyingglass-light.png?v=1713862866"
                    alt="product_features"
                    width={25}
                    height={25}
                  />
                </div> */}
              </div>
            );
          })}
        </Carousel>
      </div>
  
      <style jsx>
        {`
          .product_image_container {
            overflow: hidden;
            // padding-top: 14px;
            border-radius: 1%;
            // display: none;
            // background: #141414;
          }
          .image_tab {
            // background: #141414;
             {
              /* margin: 0 10px; */
            }
            overflow-y: hidden;
             {
              /* padding: 30px 0; */
            }
            position: relative;
            padding-bottom: 40px;
            padding-top: 10px;
          }
          .image_zoom_in {
            position: absolute;
            right: 10px;
            bottom: 10px;
            width: 25px !important;
          }
          .product_image {
             {
              /* width: 90% !important;
            min-height: 350px !important; */
            }
            margin: 0 auto;
          }
          @media (max-width: ${breakPoints.medium}) {
            .product_image {
              width: 50% !important;
            }
          }
          @media (max-width: ${breakPoints.small}) {
            .product_image {
              width: 100% !important;
            }
          }
        `}
      </style>
    </>
  )
};

export default ImageGalleryMobile;
